//* node modules
import { Routes, Route } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

//* Pages
import Main from "./pages/Main";
import Contact from "./pages/Contact";
import Application from "./pages/Application";

//* Components
import Header from "./components/Header";
import AOS from "aos";
import Loading from "./components/pages/Index/Loading";
import { useEffect } from "react";

function App() {
  AOS.init({
    delay: 300,
    once: true,
  });

  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 7000,
        }}
      />
      <Header />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/application" element={<Application />} />
      </Routes>
    </div>
  );
}

export default App;
